//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    block: { type: Object, required: true }
  },
  computed: {
    isSlider () {
      return (this.block.classNames || '').includes('slick-me')
    }
  }
}
